import { useTheme } from "../../context/ThemeContext";

export default function AdminModal({
  isOpen,
  title,
  children,
  onClose,
}) {

  const { isDark } = useTheme();

  if (!isOpen) return null;

  return (
    <div
      className="
        fixed
        inset-0
        z-50
        flex
        items-center
        justify-center
        bg-black/70
        backdrop-blur-sm
      "
    >
      <div
        className={`
          w-full
          max-w-lg
          rounded-3xl
          p-6
          border
          ${
            isDark
              ? "bg-gray-950 border-white/10"
              : "bg-white border-gray-200"
          }
        `}
      >
        <div className="flex justify-between items-center mb-6">

          <h2 className="text-xl font-semibold">
            {title}
          </h2>

          <button
            onClick={onClose}
            className="text-2xl"
          >
            ×
          </button>

        </div>

        {children}

      </div>
    </div>
  );
}